import React from 'react';

import { MCButton, Spinner } from 'src/components/basic';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { isAdminPage, lang, permissions, remCss, withRouter } from 'src/helpers';

import model from './model';
import Basic from './Basic';
import VitalInfo from './VitalInfo';
import MedicalHistory from './MedicalHistory';

const { PAGES } = permissions;

class PatientDetail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    if (this.props.router.params.id) {
      model.loadDetail(parseInt(this.props.router.params.id), () => this.back());
    }
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }
  render() {
    const patient = model.getPatient();
    return (
      <div className={'mc-container-content mc-patient-detail'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <button
            type={'button'}
            className={'mc-no-style-btn'}
            style={{ height: remCss(40) }}
            onClick={this.back}
          >
            <SVGIcon width={40} iconname={'back-icon'} />
          </button>
          <span className={'mc-grow'}>{lang.t('Patient detail')}</span>
          {patient &&
            ((patient?.createdBy === model.state.user?.id && patient?.status === 'inactive') ||
              isAdminPage()) && (
              <MCButton
                type={'link'}
                primary
                light
                radius
                medium
                style={{ height: remCss(30) }}
                to={
                  isAdminPage()
                    ? PAGES.ADMIN_PATIENTS_EDIT_PAGE.match(patient?.id)
                    : PAGES.PATIENTS_EDIT_PAGE.match(patient?.id)
                }
              >
                {lang.t('Edit patient')}
              </MCButton>
            )}
        </div>
        {!patient ? (
          <div className={'mc-flex'}>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-flex-25-col'} style={{ height: '100%', overflow: 'auto' }}>
            <div className={'mc-flex-25'}>
              <div className={'mc-flex-25 mc-grow'} style={{ height: '100%' }}>
                <Basic patient={patient} router={this.props.router} />
              </div>
              {/*<div className={'mc-flex-25 mc-grow'} style={{ height: '100%' }}>*/}
              {/*  <Notes />*/}
              {/*</div>*/}
              <div className={'mc-flex-25 mc-grow'} style={{ height: '100%' }}>
                <VitalInfo patient={patient} />
              </div>
            </div>
            <MedicalHistory router={this.props.router} />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(PatientDetail);
